export const Common = {
	'Loading...': 'Loading...',
	'We are saving your information...': 'We are saving your information...',
	'Current session is expired':
		'Your session has expired. Please sign in again.',
	'Your session will expire in {{time}} min. Renew it to keep going.':
		'Your session will expire in {{time}} min. Renew it to keep going.',
	'Renew session': 'Renew session',
	'Renewing...': 'Renewing...',
	'We could not renew your session. Please save and sign in again.':
		'We could not renew your session. Please save and sign in again.',
	Dismiss: 'Dismiss',
	Maintenance: 'Maintenance',
	'We are under maintenance. Please try again later.':
		'We are under maintenance. Please try again later.',
	'No internet connection': 'No internet connection',
	'Check your connection and try again.':
		'Check your connection and try again.',
	'Retry now': 'Retry now',
	'Retrying automatically in {{seconds}}s':
		'Retrying automatically in {{seconds}}s',
	Courses: 'Courses',
	Certificates: 'Certificates',
	'Frequent questions': 'Frequent questions',
	'My profile': 'My profile',
	Logout: 'Logout',
	'My courses': 'My courses',
	'Start Course': 'Start course',
	'Continue Course': 'Continue course',
	'Download certificate': 'Download certificate',
	'Downloading...': 'Downloading...',
	'My certificates': 'My certificates',
	Details: 'Details',
	Names: 'First names',
	Lastname: 'Last names',
	Email: 'Email',
	'Save changes': 'Save changes',
	'Saving...': 'Saving...',
	'You do not have any certificate yet':
		'You do not have any certificate yet. Keep learning!',
	Back: 'Back',
	Next: 'Next',
	'Skip recommendations': 'Skip recommendations',
	// Step 1
	'Previous recommendations to validate your identity':
		'Recommendations before validating your identity',
	'To complete this process we need:': 'To complete this process we need:',
	'Have your identity card handy': 'Have your identity card handy',
	'Find a place with good illumination': 'Find a place with good lighting',
	'The following steps are intended to facilitate registration and ensure that the delivery of your courses is transparent and of quality.':
		'The following steps are intended to facilitate registration and ensure that the delivery of your courses is transparent and of quality.',
	'We assure you that the photos you give us will be':
		'We assure you that the photos you give us will be',
	'completely confidential.': 'completely confidential.',
	'For more information on the use of data and photos, you can review the privacy policy.':
		'For more information on the use of data and photos, you can review the privacy policy.',
	'Allows Webcam access': 'Allow webcam access',
	'Your browser could ask you to enable your webcam. If you see a message like this please click on "Allow"':
		'Your browser could ask you to enable your webcam. If you see a message like this please click on "Allow"',
	'How to take a good photo of your DNI?':
		'How to take a good photo of your ID?',
	'Align the corners just in the guideline intersection':
		'Align the corners right at the guideline intersection',
	'It is important that your identity card is not bent or uneven. If it is easier for you, affirm it with both hands.':
		'It is important that your identity card is not bent or uneven. If it is easier for you, hold it with both hands.',
	'Make sure that the computer screen reflects as little as possible on your ID. If you can lower the brightness of the screen (look for the key with the sun).':
		'Make sure that the computer screen reflects as little as possible on your ID. If you can, lower the brightness of the screen (look for the key with the sun).',
	'Avoid those common mistakes': 'Avoid these common mistakes',
	'How to take a good photo of your face?':
		'How to take a good photo of your face?',
	'Position your face right at the intersection of the guide lines':
		'Position your face right at the intersection of the guide lines',
	'Focus your full face and looking straight ahead.':
		'Frame your full face and look straight ahead.',
	'Make sure your facial features stand out.':
		'Make sure your facial features stand out.',
	'Remember that you should take in a place with good lighting.':
		'Remember to take it in a place with good lighting.',
	'How to get better photos?': 'How to get better photos?',
	'Avoid those mistakes': 'Avoid these mistakes',
	'A lot of light': 'Too much light',
	'A lot of shadow or backlight': 'Too much shadow or backlight',
	'Remember that you can also complete the registration from your cell phone, you will have better quality photos.':
		'Remember that you can also complete the registration from your cell phone, where you will get better quality photos.',
	'Done!': 'Done!',
	'You can now start taking your photos and validate your identity.':
		'You can now start taking your photos and validate your identity.',
	'Open PDF': 'Open PDF',
	'You do not have courses yet': 'You do not have courses yet',
	'Load courses': 'Refresh academic load',
	'Show more': 'Show more',
	'Show less': 'Show less',
	'RUT or Email is required': 'ID or Email is required',
	'Invalid RUT or Email': 'Invalid ID or Email',
	'My finished courses': 'My finished courses',
	'Show finished courses': 'Show finished courses',
	Completed: 'Completed',
	'Quiz approved': 'Passed',
	'Quiz failed': 'Failed',
	'Certificate expires on': 'Certificate expires on',
	'The course is not available, it is not enabled, or you have to complete a previous course':
		'The course is not available, it is not enabled, or you must complete a previous course',
	Unavailable: 'Unavailable',
	Available: 'Available',
	'Course failed': 'Course failed',
	'Days remaining': 'Days remaining',
	'The course ends today': 'The course ends today',
	'Course closed': 'Course closed',
	'Course approved': 'Course approved',
	'Certificate expired': 'Certificate expired',
	'Practical course': 'Practical course',
	'The practical course is not available right now. Please try again later.':
		'The practical course is not available right now. Please try again later.',
	'Course not available': 'Course not available',
	'The certificate cannot be downloaded':
		'The certificate cannot be downloaded',
	'Course not finished': 'Course not finished',
	'The course has not been completed. Please complete the course to continue.':
		'The course has not been completed. Please complete the course to continue.',
	'Student disabled': 'Student disabled',
	'The student cannot take the course right now. Please try again later.':
		'The student cannot take the course right now. Please try again later.',
	'You can view the material by': 'You can view the material by',
	'clicking here.': 'clicking here.',
	'Error 404, the route does not exist': 'Error 404, the route does not exist',
	'Error 500, something went wrong': 'Error 500, something went wrong',
	'You can always': 'You can always',
	'go back home': 'go back home',
	'Contact support to get help if you keep seeing this error.':
		'Contact support to get help if you keep seeing this error.',
	// Misc UI
	'Abrir clase en vivo': 'Open live class',
	Accept: 'Accept',
	'Close modal': 'Close modal',
	'Course closed on': 'Course closed on',
	'Updating...': 'Updating...',
	'Step 1': 'Step 1',
	'Step 2': 'Step 2',
	'Step 3': 'Step 3',
	'Step 4': 'Step 4',
	'Step 5': 'Step 5',
	'Step 6': 'Step 6',
	'Carnet DNI': 'ID card',
	'Lamp Icon': 'Lamp icon',
	'Lock Icon': 'Lock icon',
	// PWA manifest defaults
	LMS: 'LMS',
	'A big LMS': 'A big LMS',
	'Watch the full video to continue.': 'Watch the full video to continue.',
	'The player could not be loaded. Disable your ad blocker and reload the page to continue.':
		'The player could not be loaded. Disable your ad blocker and reload the page to continue.',
	'The video could not be loaded. Please reload the page.':
		'The video could not be loaded. Please reload the page.',
	'Your progress could not be saved': 'Your progress could not be saved',
	'We could not mark this video as completed. Please try again.':
		'We could not mark this video as completed. Please try again.',
	'Try again': 'Try again',
};
